// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._0s5LO {\n  margin-left: 2px !important;\n  overflow: visible !important;\n  border-radius: 8px !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": "_0s5LO"
};
export default ___CSS_LOADER_EXPORT___;
